export let CategoryCardProps = {
    category: {require},
    categoryLinkProp: {
        default: 'product'
    }
}